import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetObjectiveProjectsList = createAsyncThunk(
  "dropdowns/GetObjectiveProjectsList",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ReportsStages/GetObjectiveProjectsList",Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddObjectiveProjects = createAsyncThunk(
  "dropdowns/AddObjectiveProjects",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ObjectiveProjects/AddObjectiveProjects",Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const UpdataObjectiveProjects = createAsyncThunk(
  "dropdowns/UpdataObjectiveProjects",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ObjectiveProjects/UpdataObjectiveProjects",Parameter
      );
     
      
      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetOneRecordObjectiveProjectsList = createAsyncThunk(
  "dropdowns/GetOneRecordObjectiveProjectsList",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ReportsStages/GetOneRecordObjectiveProjectsList",Parameter
      );
      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data,"Sdlksdklskd");

      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const DeleteObjectiveProjects = createAsyncThunk(
  "dropdowns/DeleteObjectiveProjects_",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ObjectiveProjects/DeleteObjectiveProjects",Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteObjectiveProjects = createAsyncThunk(
  "GetSpecificRowNoteObjectiveProjects/GetSpecificRowNoteObjectiveProjects",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data.filter((item) => item.incrementNumber - 1 === 1);
      //   return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Objective = createSlice({
  name: "Objective",
  initialState: {
    ObjectiveList: [],
    loadingObjectiveList: false,
    errorObjectiveList: null,

    addObjective: {},
    loadingAddObjective: false,
    errorAddObjective: null,

    updataObjective: {},
    loadingUpdataObjective: false,
    errorUpdataObjective: null,

    Objective: {},
    loadingObjective: false,
    errorObjective: null,

    DeleteObjective: [],
    loadingDeleteObjective: false,
    errorDeleteObjective: null,

    OneSpecificRowNoteObjective: {},
    loadingOneSpecificRowNoteObjective: false,
    errorOneSpecificRowNoteObjective: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetObjectiveProjectsList.pending, (state, action) => {
        state.loadingObjectiveList = true;
        state.ObjectiveList = action.payload;
        state.errorObjectiveList = null;
      })
      .addCase(GetObjectiveProjectsList.fulfilled, (state, action) => {
        state.loadingObjectiveList = false;
        state.ObjectiveList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetObjectiveProjectsList.rejected, (state, action) => {
        state.loadingObjectiveList = false;
        state.errorObjectiveList = action.payload;
      });

    builder
      .addCase(AddObjectiveProjects.pending, (state, action) => {
        state.loadingAddObjective = true;
        state.addObjective = action.payload;
        state.errorAddObjective = null;
      })
      .addCase(AddObjectiveProjects.fulfilled, (state, action) => {
        state.loadingAddObjective = false;
        state.addObjective = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddObjectiveProjects.rejected, (state, action) => {
        state.loadingAddObjective = false;
        state.errorAddObjective = action.payload;
      });

    builder
      .addCase(UpdataObjectiveProjects.pending, (state, action) => {
        state.loadingUpdataObjective = true;
        state.updataObjective = action.payload;
        state.errorUpdataObjective = null;
      })
      .addCase(UpdataObjectiveProjects.fulfilled, (state, action) => {
        state.loadingUpdataObjective = false;
        state.updataObjective = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdataObjectiveProjects.rejected, (state, action) => {
        state.loadingUpdataObjective = false;
        state.errorUpdataObjective = action.payload;
      });

    builder
      .addCase(GetOneRecordObjectiveProjectsList.pending, (state, action) => {
        state.loadingObjective = true;
        state.Objective = action.payload;
        state.errorObjective = null;
      })
      .addCase(GetOneRecordObjectiveProjectsList.fulfilled, (state, action) => {
        state.loadingObjective = false;
        state.Objective = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneRecordObjectiveProjectsList.rejected, (state, action) => {
        state.loadingObjective = false;
        state.errorObjective = action.payload;
      });

    builder
      .addCase(DeleteObjectiveProjects.pending, (state, action) => {
        state.loadingDeleteObjective = true;
        state.DeleteObjective = action.payload;
        state.errorDeleteObjective = null;
      })
      .addCase(DeleteObjectiveProjects.fulfilled, (state, action) => {
        state.loadingDeleteObjective = false;
        state.DeleteObjective = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteObjectiveProjects.rejected, (state, action) => {
        state.loadingDeleteObjective = false;
        state.errorDeleteObjective = action.payload;
      })

      .addCase(GetSpecificRowNoteObjectiveProjects.pending, (state, action) => {
        state.loadingOneSpecificRowNoteObjective = true;
        state.OneSpecificRowNoteObjective = action.payload;
        state.errorOneSpecificRowNoteObjective = null;
      })
      .addCase(
        GetSpecificRowNoteObjectiveProjects.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteObjective = false;
          state.OneSpecificRowNoteObjective = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificRowNoteObjectiveProjects.rejected,
        (state, action) => {
          state.loadingOneSpecificRowNoteObjective = false;
          state.errorOneSpecificRowNoteObjective = action.payload;
        }
      );
  

  },
});

export default Objective.reducer;
